import useDisableThirdPartyScripts from '@hooks/useDisableThirdPartyScripts'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import ScribbleWidget from './ScribbleWidget'

interface ScribbleTickerProps {
  id: string
  options: {
    pageSize: number
    pollInterval: number
  }
}

const ScribbleTicker: FunctionComponent<ScribbleTickerProps> = (props) => {
  const disableThirdPartyScripts = useDisableThirdPartyScripts()

  if (disableThirdPartyScripts) {
    return null
  }

  return <ScribbleWidget element={props} />
}

const widget: CookWidget = {
  kind: ['widget', 'ticker', 'scribble'],
  component: ScribbleTicker,
}

export default widget
